module.exports = __webpack_public_path__ + "media/images/heroes/norton-a8bff78adb6c75ed11e6683818559835.jpg";